import React from 'react';
import styles from './SGSIconBadge.module.scss';
import classnames from 'classnames';

type Props = {
    image: string;
    color: 'green' | 'orange';
    className?: string;
};

const SGSIconBadge: React.FC<Props> = ({ image, color, className }) => {
    return <div className={classnames(styles.container, styles[color], className)}>{image}</div>;
};

export default SGSIconBadge;
